var _text, _rect, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInssureLogoDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 26,
    fontFamily: "'Plus Jakarta Sans', 'Segoe UI', Arial, sans-serif",
    fontSize: 23,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, "ins")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 1,
    width: 64,
    height: 30,
    rx: 7,
    fill: "#0891B2"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 67,
    y: 25,
    textAnchor: "middle",
    fontFamily: "'Plus Jakarta Sans', 'Segoe UI', Arial, sans-serif",
    fontSize: 23,
    fontWeight: 800,
    fill: "#FFFFFF"
  }, "Sure")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInssureLogoDark);
export default __webpack_public_path__ + "static/media/inssure-logo-dark.89e1577393c0e7ec5cba16c8ffa47e59.svg";
export { ForwardRef as ReactComponent };